<div class="wrapper">
  <div class="header">
    <span
      class="backBtn clickable"
      (click)="onClose()"
      i18n="@@general.documents"
      ><img src="assets/Keen&Wise_back.png" /> Documents</span
    >
  </div>
  <div class="body">
    <div class="card">
      <span class="card-title" i18n="@@document.list.rejection.preview.reason"
        >Reason for rejection</span
      >
      <span>{{ item.ownerRemarks.remarks }}</span>
    </div>
    <div class="buttons">
      <button
        class="back-to-pending button customBtn"
        (click)="onBackToPending()"
      >
        <div class="masked-button">
          <div class="mask"></div>
        </div>
        <span
          class="btnText"
          i18n="@@document.list.rejection.preview.backtopending"
          >set back to pending</span
        >
      </button>
      <button class="upload-new button customBtn" (click)="onUploadNew()">
        <div class="masked-button">
          <div class="mask"></div>
        </div>
        <span
          class="btnText"
          i18n="@@document.list.rejection.preview.uploadagreement"
          >upload agreement</span
        >
      </button>
    </div>
  </div>
</div>
